import React from 'react';

import { Guides } from '../../../homepage/Components/Guides/Guides';
import { GuideData } from '../../../homepage/Components/Guides/Guides.types';

import styles from './GuidesSection.scss';

type GuidesSectionProps = {
  analyticsEvents: {
    onGuideClick: (props: { label: string; url: string }) => void;
    onLoad: (label: string) => void;
  };
};

export const GuidesSection = ({ analyticsEvents }: GuidesSectionProps) => {
  const { onGuideClick, onLoad } = analyticsEvents;

  return (
    <Guides
      {...{ onLoad }}
      onGuideClick={(guide: GuideData) => onGuideClick({ label: guide.title, url: guide.link })}
      titleClassName={styles.sectionTitle}
      wrapperClassName={styles.component}
    />
  );
};
